/**
 * Navigates to the given location by setting the window location href.
 * WE can't mock out window.location.href in Jest because the jest maintainers are being *engineers* about it
 * so we have to use a layer of indirection to be able to mock it out in tests.
 * @param href - the URL to set as the window location href
 */
export function setWindowHref(href: string) {
  if (typeof window !== 'undefined' && window.location) {
    window.location.href = href;
  } else {
    console.warn('setWindowHref called outside of browser context to set href to:', href);
  }
}
